// extracted by mini-css-extract-plugin
module.exports = {"container":"_8b792f91","contact1stdibs":"_255b413c","contact1Stdibs":"_255b413c","iconWrapper":"_e48b9e4e","wrapper":"_ece54ac5"};